var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CrudList',{attrs:{"title":"Opciones","storeName":"Options","labelAddNew":"Agregar","canAdd":true,"canEdit":true,"canDelete":true,"sortable":"","canOther":true,"labelOther":"Respuestas","urlOther":"answers","next-link":"/admin/trakers","breadcrumbs":[
      {
        text: 'Reservas y estadías',
        disabled: false,
        href: '/admin/options'
      },
      {
        text: 'Opciones',
        disabled: false,
        href: '#'
      },
    ]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }